import React from 'react'
import { FRONT, TRANSLATION } from '../constants/state'
import { compose } from 'underscore'
import { connect } from 'react-redux'
import toJS from '../hoc/toJS'
import getData from '../functions/getData'
import MovieTimesPeriodeDaysItemAttributes from './MovieTimesPeriodeDaysItemAttributes'


const mapStateToProps = (state, ownProps) => ({
    cinemaDataFront: getData(state, FRONT),
    translation: getData(state, TRANSLATION)
})

const MovieTimesPeriodeDaysItemAttributesContainer = ({translation, cinemaDataFront, hideAttributes, attributes, theatreName=false, hideTheatres=false, bluePricesClass='', seatClasses=[]}) => {
    const {hidden_attributes, attribute_styling, hide_theatres, show_seatclasses_array} = cinemaDataFront

    // two different hideTheatres/hide_theatres so that you can hide the theatres for a specific view besides the settings

    return <MovieTimesPeriodeDaysItemAttributes
        attributes={attributes} 
        hideTheatres={hideTheatres ? hideTheatres : hide_theatres} 
        attributeStyling={attribute_styling} 
        showSeatClassesArray={show_seatclasses_array} 
        seatClasses={seatClasses}
        hideAttributes={hideAttributes} 
        hiddenAttributes={hidden_attributes} 
        translation={translation} 
        theatreName={theatreName} 
        bluePricesClass={bluePricesClass}
        /> 
}

export default compose(
    connect(mapStateToProps, null),
    toJS()
)(MovieTimesPeriodeDaysItemAttributesContainer)